// src/components/global/Table/ArchiveButton.jsx
import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Archive } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ArchiveButton = ({
    to,
    visible = true,
    archiveLabelAr = "الأرشيف",
    archiveLabelEn = "Archive",
    size = "medium",
    disabled = false,
}) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const navigate = useNavigate();
    if (!visible) return null;


    return (
        <Tooltip title={isArabic ? "الأرشيف" : "Archive"}>
            <Button
                variant="outlined"
                onClick={() => !disabled && navigate(to)}
                disabled={disabled}
                startIcon={<Archive />}
                // onClick={() => navigate(to)}
                size={size}
                sx={{
                    borderRadius: 2.5,
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    px: 2.5,
                    mr: 1,
                    color: 'primary.main',
                    borderColor: 'primary.light',
                    '&:hover': {
                        borderColor: 'primary.main',
                        bgcolor: 'primary.50'
                    }
                }}
            >
                {isArabic ? archiveLabelAr : archiveLabelEn}
            </Button>
        </Tooltip>
    );
};

export default ArchiveButton;
